import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import select2Factory from 'select2';
import 'select2/dist/css/select2.min.css';
import './select2-theme.css';

// Under webpack's AMD loader Select2 attaches itself to jQuery; the CommonJS build (used by Jest
// and some bundlers) only exports a factory. Cover both.
if (!$.fn.select2 && typeof select2Factory === 'function') select2Factory(window, $);

/**
 * Select2 dropdown (searchable) for React.
 *
 * React renders the <option>s and owns `value`; Select2 only draws the box and the list. Pass
 * `options` as [{ value, label }]. `onChange` receives the new value as a string. Do not put the
 * native `required` attribute on it (the real <select> is hidden, so the browser could not show
 * its message); validate in your own submit handler instead.
 */
const Select2 = ({ id, value, onChange, options, placeholder = 'Select…', disabled = false, allowClear = false, minimumResultsForSearch = 6 }) => {
  const ref = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  // Create once, destroy on unmount.
  useEffect(() => {
    const $el = $(ref.current);
    $el.select2({ width: '100%', placeholder, allowClear, minimumResultsForSearch });
    // A plain 'change' handler: Select2 triggers it on user picks. Our own sync below uses the
    // namespaced 'change.select2', which does not reach this handler, so there is no loop.
    $el.on('change', (e) => onChangeRef.current && onChangeRef.current(e.target.value));
    return () => {
      $el.off('change');
      if ($el.data('select2')) $el.select2('destroy');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Keep the widget in step with React's value and option list.
  useEffect(() => {
    $(ref.current).val(value === undefined || value === null ? '' : String(value)).trigger('change.select2');
  }, [value, options]);

  useEffect(() => {
    $(ref.current).prop('disabled', disabled).trigger('change.select2');
  }, [disabled]);

  return (
    <select ref={ref} id={id} defaultValue="">
      <option value="" />
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
};

export default Select2;
